import useIsMobile from '@/hooks/useIsMobile';
import TopProductInCartDesktop from './desktop';
import TopProductInCartMobile from './mobile';
import useTopProductInCart from './useTopProductInCart';

const TopProductInCart = () => {
  const isMobile = useIsMobile(992);
  const viewModel = useTopProductInCart();

  if (isMobile) {
    return <TopProductInCartMobile viewModel={viewModel} />;
  }

  return <TopProductInCartDesktop viewModel={viewModel} />;
};

export default TopProductInCart;
